import { render } from "./Footer.vue?vue&type=template&id=3e37f50f"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3e37f50f&lang=css"

import exportComponent from "C:\\Users\\kamon\\Documents\\Workspace\\ECOUPONS\\coupons-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__